import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class WaterSensorIcon extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string
    };

    static defaultProps = {
        size: 50,
        color: '#8e8e8e'
    };
    render() {
        const { color, size } = this.props;
        return (
            <svg height={(size / 1.5).toString()} width={(size / 1.5).toString()} viewBox="0 0 215.99 300">
                <path
                    d="M135.7 33.07C128.77 22.89 122.66 13.51 116.99 5a12.4 12.4 0 0 0-3.26-3.26A10.62 10.62 0 0 0 98.99 5c-5.3 8.56-11.41 17.52-18.75 28.12C48.08 80.35-.01 151.66-.01 192.41a107.51 107.51 0 0 0 31.79 76.21A108.87 108.87 0 0 0 107.99 300a108.53 108.53 0 0 0 108-108c0-40.74-48.09-111.65-80.29-158.93zm36.52 198.85a72.43 72.43 0 0 1-26.86 26 12.3 12.3 0 0 1-6.18 1.67 12.52 12.52 0 0 1-3.26-.43 13.64 13.64 0 0 1-8.28-6.56 12.13 12.13 0 0 1-1.07-9.63 13.28 13.28 0 0 1 6-7.67 47.49 47.49 0 0 0 18-17.16 50.27 50.27 0 0 0 7.41-23.79 12.87 12.87 0 0 1 4.26-8.75 12.05 12.05 0 0 1 9.14-3.16 12.83 12.83 0 0 1 8.69 4.25 12.27 12.27 0 0 1 3.16 9.14 71.22 71.22 0 0 1-11 36.1z"
                    fill={color}
                />
            </svg>
        );
    }
}

export default withTheme(WaterSensorIcon);



// WEBPACK FOOTER //
// ./data/common/iconsvg/WaterSensorIcon.js